import AccountsReceivableTable from './AccountsReceivableTable';
export default AccountsReceivableTable;
